import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderComponent from '../../components/header/Header.component';
import FooterComponent from '../../components/portalComponents/Footer.component';
import { endpoints, estateEndpoints, getFileUrl, POST, requestInfo } from '../../services/modulesServices/userManagement.api';
import { useTranslation } from 'react-i18next';
import PopUps from '../../components/PopUps';
import { OwnershipTable } from '../modules/UserManagement/EnterpriseModule/OwnershipTable';
import { cross } from '../../utils/Logo';
import Loading from '../../components/portalComponents/Loading.component';
import GenericActionTable from '../../components/moduleCommonFormik/GenericActionTable';
import { convertTableDateFormat } from '../../utils/utils';
import { ADVERTISEMENT_TABLE_COLUMNS } from '../modules/EstateManagement/ApplyForPlot/AdvertisementTable.const';
import { ADVERTISEMENT_SEARCH_COLUMNS } from '../modules/EstateManagement/Advertisement/Searchadvertisement/searchAdv.const';

export default function AdvertisementPublicPage(props: any) {
    const { t } = useTranslation();
    const [rowData, setRowData] = useState<any>(null);
    const [modalDetails, setModalDetails] = useState({});
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchAllCirculars = async () => {
            try {
                setIsLoading(true);
                const { data } = await POST('/idc-estate-service/advertisement/_search?evaluatedStatuses=OPEN,CLOSED,APPROVED&plotDetailsRequired=false', { RequestInfo: requestInfo() });
                let statues = await getStatus();
                if (data.advertisementsDetails.length === 0) {
                    setModalDetails({ show: true, title: t('ERROR', 'Error!'), para: t('NO_DATA_FOUND', 'No Data Found'), img: cross, type: 'error', reUpload: 'OK' });
                    return;
                }

                const newData = data.advertisementsDetails.map((e: any) => ({
                    ...e,
                    publicationDate: convertTableDateFormat(e.publicationDate),
                    submissionStartDate: convertTableDateFormat(e.submissionStartDate),
                    submissionEndDate: convertTableDateFormat(e.submissionEndDate),
                    status: statues.find((status: any) => status.code === e.status)?.name || e.status
                }));
                setRowData(newData);
                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong');
                setModalDetails({ show: true, title: t('ERROR', 'Error!'), para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        };
        fetchAllCirculars();
    }, []);

    const getStatus = async () => {
        const payload: any = {
            RequestInfo: requestInfo(),
            MdmsCriteria: {
                tenantId: 'ga',
                moduleDetails: [
                    {
                        moduleName: 'Estate',
                        masterDetails: [
                            {
                                name: 'AdvertisementStatus',
                                filter: '[?(@.active == true)]'
                            }
                        ]
                    }
                ]
            }
        };
        const res = await POST('/egov-mdms-service/v1/_search', payload);
        const statusArray = res.data?.MdmsRes?.Estate?.AdvertisementStatus || [];
        const status = statusArray.map((status: any) => ({
            code: status.code,
            name: status.name
        }));

        return status;
    };

    const onClickDownloadItem = async (rowData: any) => {
        try {
            const url = await getFileUrl(rowData.docReferenceId);
            window.open(url, '_blank');
        } catch (err: any) {
            let errMsg = err.response?.data?.errorMessage || t('SOMETHING_WENT_WRONG', 'Something went wrong');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <PopUps modalDetails={modalDetails} setModalDetails={setModalDetails} />
                    <HeaderComponent />
                    <div className='mx-5 p-5 font-inter'>
                        <div style={{ width: '764px', height: '14px' }}>
                            <p className='breadcrumbs'>
                                <Link className='text-decoration-none' to='/goa-idc/'>
                                    {t('HOME', 'Home')}
                                </Link>{' '}
                                / {t('Advertisements', 'Advertisements')}
                            </p>
                        </div>
                        <div className='col-md-8' style={{ fontWeight: 500, fontSize: '48px', lineHeight: '76.8px', letterSpacing: -1 }}>
                            {t('Advertisements', 'Advertisements')}
                        </div>
                        <OwnershipTable
                            column={ADVERTISEMENT_SEARCH_COLUMNS}
                            tableRowData={rowData}
                            searchBarPlaceholder={t('SEARCH_ADVERTISMENT', 'Search Advertisment')}
                            itemsPerPage={5}
                            additionalMethod={onClickDownloadItem}
                        ></OwnershipTable>
                    </div>
                    <FooterComponent />
                </>
            )}
        </>
    );
}
